export const BACKEND_HOST = process.env.REACT_APP_CANVA_INTEGRATION_URL || 'http://127.0.0.1:3003';
